import Helper from '@/utils/helper'
import Tracks from '@/app/service/api/model/tracks'

class Ticket {
  constructor ({ id, ticketNumber, name, seatLabel, callCount, tracks, title, screenStateId, clientStateId }) {
    if (!Helper.isDefined(id)) {
      throw new Error('Id is undefined')
    }
    if (!Helper.isDefined(ticketNumber)) {
      throw new Error('TicketNumber is undefined')
    }

    this.id = id
    this.callCount = callCount
    this.ticketNumber = ticketNumber
    this.name = name
    this.seatLabel = Helper.getValue(seatLabel, '-')
    this.tracks = null
    this.title = title
    this.screenStateId = screenStateId
    this.clientStateId = clientStateId
    if (Helper.isDefined(tracks)) {
      if (Helper.isDefined(tracks.files) && Helper.isNotEmpty(tracks.files)) {
        this.tracks = new Tracks(tracks).getFiles()
      }
    }
  }

  setTitle (value) {
    this.title = value
  }

  getTitle () {
    return this.title
  }

  getId () {
    return this.id
  }

  getCallCount () {
    return this.callCount
  }

  getTracks () {
    return this.tracks
  }

  getTicketNumber () {
    return this.ticketNumber
  }

  getName () {
    return this.name
  }

  getSeatLabel () {
    return this.seatLabel
  }

  getClientStateId () {
    return this.clientStateId
  }

  getScreenStateId () {
    return this.screenStateId
  }

  toString () {
    return 'Ticket{' +
      'id=' + '\'' + this.id + '\'' +
      ', ticketNumber=' + '\'' + this.ticketNumber + '\'' +
      ', name=' + '\'' + this.name + '\'' +
      ', seatLabel=' + '\'' + this.seatLabel + '\'' +
      ', title=' + '\'' + this.title + '\'' +
      '}'
  }
}

export default Ticket
